import { useEffect, useState } from "react";
import axios from "axios";
import Config from "../Config";

const readCategoryList = (response) => {
  const body = response?.data ?? {};
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.data)) return body.data;
  if (Array.isArray(body.data?.data)) return body.data.data;
  return [];
};

export function useMarketplaceCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    axios
      .get(`${Config.backendDomain}categories`)
      .then((response) => {
        if (!cancelled) setCategories(readCategoryList(response));
      })
      .catch(() => {
        if (!cancelled) setCategories([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, loading };
}
